import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nominal Denda", -1)
const _hoisted_3 = { class: "p-inputgroup flex-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp.", -1)
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "birth-date",
  class: "label-text"
}, "Tanggal Jatuh Tempo (opsional)", -1)
const _hoisted_8 = { class: "input-icon-right" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar text-base font-bold" }, null, -1)
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Keterangan", -1)
const _hoisted_13 = { class: "invalid-feedback" }
const _hoisted_14 = { class: "container-btn-action" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Simpan")

import { PropType, computed, ref, onMounted, getCurrentInstance } from 'vue'
import { IVerbal } from '@/utils/interfaces/iVerbal'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import { StatusVerbal } from '@/utils/enum/StatusVerbal'

// Components
import { Form, Field } from 'vee-validate'
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import { DatePicker } from 'v-calendar'
import rgxExp from '@/utils/helpers/regExp'
import apiUseCase from '@/usecase/apiUseCase'
import ItemsStatus from '../data/listStatus'

interface IFineForm {
  Nominal: number,
  Description: string | null,
  DueDate: string | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FineForm',
  props: {
  dataDetail: {
    type: Object as PropType<IVerbal>
  }
},
  emits: ["onReload"],
  setup(__props, { emit }: { emit: ({
  (e: 'onReload'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const endpoint = '/transaction/v1/Verbal'

const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties



const dataDetail = computed(() => props.dataDetail)
const store = useStore()

const initialValues = ref({
  Nominal: dataDetail.value?.Penalty,
  Description: dataDetail.value?.PenaltyDescription,
  DueDate: dataDetail.value?.PenaltyDueDate
})

const schema = Yup.object().shape({
  Nominal: Yup.number()
    .typeError('Denda tidak boleh kosong')
    .required('Denda tidak boleh kosong')
    // .min(0, 'Denda Denda refund minimal 0')
    .test('maxDigits', 'Denda tidak valid', (value) => {
      const valConfert = value.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      return numberRegex.test(valConfert)
    }),
  Description: Yup.string()
    .required('Keterangan tidak boleh kosong')
    .matches(rgxExp.notSpaceInFirstChar, 'Keterangan tidak valid')

})

const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
}

const processChangeStatus = (id: string) => {
  apiUseCase.put(`${endpoint}/ChangeStatus/${id}`, {
    MsStatusId: ItemsStatus.find((v) => v.label === StatusVerbal.Penalty)?.value
  })
    .then(({ error, message }) => {
      store.dispatch('hideLoading')
      if (!error) {
        hideSidebar()
        store.dispatch('setReloadDataList')
        emit('onReload')
        $toast.add({
          severity: 'success',
          detail: 'Berhasil mengubah denda.',
          group: 'bc',
          closable: false,
          life: 3000
        })
      } else {
        $toast.add({
          severity: 'error',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
}

const processSubmit = (val: IFineForm) => {
  store.dispatch('showLoading')
  const payload = {
    penalty: val.Nominal,
    penaltyDescription: val.Description,
    penaltyDueDate: val.DueDate
  }
  const idVerbal = dataDetail.value?.Id as string
  apiUseCase.postOrPut(`${endpoint}/AddPenaltyNominal`, idVerbal, payload)
    .then(({ error, message }) => {
      if (!error) {
        processChangeStatus(idVerbal)
      } else {
        store.dispatch('hideLoading')
        $toast.add({
          severity: 'error',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
}

const onSubmit = (val: any) => {
  try {
    processSubmit(val)
  } catch (error) {
    console.log('catch wher err', error)
  }
}

onMounted(() => {
  store.dispatch('setTitleFormSidebarDl', 'Lengkapi Detail Denda')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues.value,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Field), {
            name: "Nominal",
            class: _normalizeClass(`input-primary ${errors.Nominal ? 'input-invalid' : ''}`)
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_unref(InputNumber), {
                  modelValue: values.Nominal,
                  "onUpdate:modelValue": ($event: any) => ((values.Nominal) = $event),
                  class: _normalizeClass(`${errors.Nominal ? 'input-invalid' : ''}`),
                  id: "Nominal",
                  placeholder: "0",
                  min: 0,
                  currency: "IDR",
                  locale: "id-ID",
                  step: 0.25,
                  inputId: "refund-amount",
                  onInput: (v) => {
                setFieldValue('Nominal', v.value)
              },
                  onBlur: field.onBlur,
                  allowEmpty: false,
                  autocomplete: "off"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput", "onBlur"])
              ])
            ]),
            _: 2
          }, 1032, ["class"]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(errors.Nominal), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(Field), { name: "DueDate" }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(DatePicker), _mergeProps(field, {
                modelValue: values.DueDate,
                "onUpdate:modelValue": [($event: any) => ((values.DueDate) = $event), (val) => setFieldValue('DueDate', val)],
                masks: {
              input: 'DD/MM/YYYY'
            },
                "min-date": new Date()
              }), {
                default: _withCtx(({ togglePopover, inputValue }) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(InputText), {
                      id: "birth-date",
                      "aria-describedby": "birth-date-help",
                      placeholder: "Masukkan Tanggal Jatuh Tempo",
                      value: inputValue,
                      class: _normalizeClass(`input-primary ${errors.DueDate ? 'input-invalid' : ''}`),
                      onClick: togglePopover,
                      readonly: ""
                    }, null, 8, ["value", "class", "onClick"]),
                    _hoisted_9
                  ])
                ]),
                _: 2
              }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_10, _toDisplayString(errors.DueDate), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_unref(Field), {
            name: "Description",
            as: "textarea",
            placeholder: "Tulis Keterangan",
            class: _normalizeClass(`input-primary ${errors.Description ? 'input-invalid' : ''}`)
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(errors.Description), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            id: "Submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema", "initial-values"])
  ]))
}
}

})